import Fetch from "../../helpers/Fetch";
import SecukeyDTO from "../dtos/Secukey";

interface AddPayload {
  name: string,
  internalId?: string,
  iconUrl: string,
  description: string,
  tileColor: string,
  lastUpdate: string,
  userId?: number | null,
  deleted: boolean,
}

export async function listSecukeys(): Promise<SecukeyDTO[]> {
  const token = localStorage.getItem('id_token');
  const fetchRequest = new Fetch<SecukeyDTO[]>(`/secukeys`, {
    method: "GET",
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    },
  })

  await fetchRequest.fetch();

  const status = fetchRequest.getStatus();

  if (status === 'success') {
    return fetchRequest.getPayload();
  }
  throw new Error('Failed to fetch secukeys');
}

export async function listUserSecukeys(userId?: number): Promise<SecukeyDTO[]> {
  const token = localStorage.getItem('id_token');
  const fetchRequest = new Fetch<SecukeyDTO[]>(`/secukeys/user/${userId}`, {
    method: "GET",
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    },
  })

  await fetchRequest.fetch();

  const status = fetchRequest.getStatus();

  if (status === 'success') {
    return fetchRequest.getPayload();
  }
  throw new Error('Failed to fetch logged user secukeys');
}

export async function listSecukeyDetails(itemId?: string): Promise<SecukeyDTO> {
  const token = localStorage.getItem('id_token');
  const fetchRequest = new Fetch<SecukeyDTO>(`/secukeys/${itemId}`, {
    method: "GET",
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    },
  })

  await fetchRequest.fetch();

  const status = fetchRequest.getStatus();

  if (status === 'success') {
    return fetchRequest.getPayload();
  }
  throw new Error('Failed to fetch secukey details');
}


export async function addSecukey(form: AddPayload): Promise<SecukeyDTO | SecukeyError> {
  const token = localStorage.getItem('id_token');
  const fetchRequest = new Fetch<SecukeyDTO>(`/secukeys`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    },
    body: JSON.stringify(form)
  });

  await fetchRequest.fetch();

  const status = fetchRequest.getStatus();

  if (status === 'success' || status === 'error') {
    return fetchRequest.getPayload();
  }
  throw new Error(`Failed to update secukey`);
}

export async function updateSecukey(form: AddPayload, itemId: string): Promise<SecukeyDTO | SecukeyError> {
  const token = localStorage.getItem('id_token');
  const fetchRequest = new Fetch<SecukeyDTO>(`/secukeys/${itemId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    },
    body: JSON.stringify(form)
  });

  await fetchRequest.fetch();

  const status = fetchRequest.getStatus();

  if (status === 'success' || status === 'error') {
    return fetchRequest.getPayload();
  }
  throw new Error(`Failed to update secukey`);
}

export type SecukeyError = {
  error: {
    field: keyof AddPayload,
    code: string,
  }
}